import React, { createContext, useContext } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import { useCycleSessions } from '../../pages/Planning/hooks/useCycleSessions'
import { ICycleData } from '../../pages/Planning/types/cycleSession'

interface ITimerDataContext {
  cycleData: ICycleData | null
  loading: boolean
  error: string | null
  refetch: () => void
}

const TimerDataContext = createContext<ITimerDataContext | undefined>(undefined)

/**
 * Provider que gerencia os dados das sessões do ciclo de forma centralizada
 * Evita múltiplas chamadas à API quando vários componentes usam useTimer
 */
export const TimerDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const currentPlanId = useSelector((state: RootState) => state.studyPlan.currentPlanId)

  // Única chamada a useCycleSessions para toda a aplicação
  const { data, loading, error, refetch } = useCycleSessions(currentPlanId)

  return (
    <TimerDataContext.Provider
      value={{
        cycleData: data,
        loading,
        error,
        refetch,
      }}
    >
      {children}
    </TimerDataContext.Provider>
  )
}

/**
 * Hook para acessar os dados das sessões do ciclo
 */
export const useTimerData = (): ITimerDataContext => {
  const context = useContext(TimerDataContext)

  if (context === undefined) {
    throw new Error('useTimerData must be used within a TimerDataProvider')
  }

  return context
}
